import Hero from '../components/home/Hero'
import Why from '../components/home/Why'
import Services from '../components/home/Services'
import HowItWorks from '../components/home/HowItWorks'
import Logistics from '../components/home/Logistics'
import FAQ from '../components/home/FAQ'
import Insights from '../components/home/Insights'
import Contact from '../components/home/Contact'

function Home() {
  return (
    <>
      <Hero />
      <Why /> 
      <Services />
      <HowItWorks />
      <Logistics />
      <FAQ />
      <Insights />
      <Contact />
    </>
  )
}

export default Home
